import React, { useState, useEffect } from 'react';
import { isEmailValid } from '@hapi/address';
import {
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Button,
  Label,
  Row,
  Col,
  Alert
} from 'reactstrap';
import { useRouter } from 'next/router';

const PAYMENT_LOCALES = { nl: 'nl_NL', en: 'en_US' };
const DEFAULT_LOCALE = 'en';

function isValidAmount(amount) {
  return parseInt(amount) > 0;
}

export default function DonationForm({
  list_id,
  default_amount = 25,
  amounts = [25, 50, 100]
}) {
  const [email, setEmail] = useState('');
  const [info, setInfo] = useState('');
  const [amount, setAmount] = useState(default_amount);
  const [subscribe, setSubscribe] = useState(false);
  const [paymentLocale, setPaymentLocale] = useState('');
  const { query } = useRouter();

  useEffect(() => {
    const locale = navigator.language.split('-')[0];
    setPaymentLocale(
      locale in PAYMENT_LOCALES
        ? PAYMENT_LOCALES[locale]
        : PAYMENT_LOCALES[DEFAULT_LOCALE]
    );
  }, []);

  const emailValid = email && isEmailValid(email);
  const amountValid = isValidAmount(amount);
  const valid =
    (subscribe ? emailValid === true : emailValid !== false) &&
    amountValid === true;

  return (
    <Form method="post" action="/api/payment">
      {'error' in query && (
        <Alert color="danger" className="mt-4">
          The payment did not succeed, please try after some time
        </Alert>
      )}
      <Input type="hidden" name="locale" value={paymentLocale} />
      <Input type="hidden" name="currency" value="EUR" />
      <Input type="hidden" name="list_id" value={list_id} />
      <FormGroup className="mb-1">
        <Label for="email">Email {!!subscribe && '*'}</Label>
        <Input
          id="email"
          type="email"
          name="email"
          value={email}
          invalid={subscribe ? !emailValid : emailValid === false}
          onChange={(e) => setEmail(e.target.value)}
        />
      </FormGroup>
      {!!list_id && (
        <FormGroup check className="mb-3">
          <Label check>
            <Input
              type="checkbox"
              name="list_subscribe"
              onChange={(e) => setSubscribe(e.target.checked)}
            />{' '}
            <span className="pl-2">Subscribe to newsletter</span>
          </Label>
        </FormGroup>
      )}
      <FormGroup>
        <Label for="amount">Donation amount *</Label>
        {!!amounts && (
          <Row className="mb-2" fluid>
            {amounts.map((amt, idx) => (
              <Col sm={4} key={idx}>
                <Button
                  block
                  outline={amt !== amount}
                  onClick={() => setAmount(amt)}>
                  € {amt}
                </Button>
              </Col>
            ))}
          </Row>
        )}
        <InputGroup>
          <InputGroupText>€</InputGroupText>
          <Input
            id="amount"
            type="number"
            name="amount"
            value={amount}
            invalid={amountValid === false}
            onChange={(e) => setAmount(e.target.value)}
          />
        </InputGroup>
      </FormGroup>
      <FormGroup className="mb-1">
        <Label for="info">Message (optional)</Label>
        <Input
          id="info"
          type="textarea"
          name="info"
          rows={3}
          placeholder="What do you find meaningful about our work? How does it resonate with you?"
          value={info}
          onChange={(e) => setInfo(e.target.value)}
        />
      </FormGroup>
      <Button color="primary" type="submit" disabled={valid === false}>
        Donate
      </Button>
    </Form>
  );
}
